import Vue from 'vue';
import { DataService } from '../../data.service';

const chartID = 'getCountyImperviousAreaPercentage';
/**
 * Tab 2: Developed: Percent Area That Is Impervious Surface
 * getCountyImperviousAreaPercentage
 */
export class Tab2Chart2 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0], response.data.fromYear, response.data.toYear);
            }
        })
        this.renderChart();
    }

    updateChartData(response, fromYear, toYear) {
        this.chart.chartOptionsA.series[0].data = [+response.StartDate];
        this.chart.chartOptionsA.yAxis.title.text = fromYear;
        this.chart.chartOptionsB.series[0].data = [+response.EndDate];
        this.chart.chartOptionsB.yAxis.title.text = toYear;
        this.chart.infographic.loading = false;
    }

    renderChart() {
        let gaugeOptionsA = {
            chart: {
                type: 'solidgauge'
            },
            tooltip: {
                enabled: false
            },
            pane: {
                center: ['50%', '60%'],
                size: '100%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor: '#eeeeee',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc',
                    borderWidth: 0
                }
            },
            yAxis: {
                lineWidth: 0,
                minorTickInterval: null,
                tickAmount: 2,
                min: 0,
                max: 100,
                stops: [
                    [1, '#C84031'] // green
                ],
                title: {
                    y: -50,
                    text: '1996'
                },
                labels: {
                    y: 16
                }
            },
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        y: -40,
                        borderWidth: 0,
                        useHTML: true,
                        style: {
                            fontSize: "15px",
                            textAlign: "center"
                        }
                    }
                }
            },
            series: [{
                name: 'Percent Coverage',
                data: [37.23],
                dataLabels: {
                    format: '<div>{y}</span><br/>' + '<span style="font-size:15px;color:silver">%</span></div>'
                },
                tooltip: {
                    valueSuffix: '%'
                }
            }]
        };

        let gaugeOptionsB = JSON.parse(JSON.stringify(gaugeOptionsA));

        //initial placeholder values
        gaugeOptionsA.yAxis.title.text = '1996';
        gaugeOptionsB.yAxis.title.text = '2010';

        //initial placeholder values for data
        gaugeOptionsB.series[0].data = [17.8];
        gaugeOptionsA.series[0].data = [35.6];

        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Percent Area That Is Impervious Surface',
                        loading: true
                    },
                    animationDuration: 1000,
                    updateArgs: [true, true, { duration: 1000 }],
                    chartOptionsA: gaugeOptionsA,
                    chartOptionsB: gaugeOptionsB
                }
            },
            computed: {
                chartVal: function () {
                    return 0;
                }
            }
        });
        //end vue component

    }
}
